import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class Recours {
    static jsonMap = {
        dateRecours: { key: 'dateRecours', converter: new DateConverter(), optional: true },
        dateNouvelleExpertise: { key: 'dateNouvelleExpertise', converter: new DateConverter(), optional: true },
        nouveauPrelevement: { key: 'nouveauPrelevement', optional: true },
        idCommission: { key: 'idCommission', optional: true },
        idNouveauPrelevement: { key: 'idNouveauPrelevement', optional: true }
    };

    dateRecours: moment.Moment;
    dateNouvelleExpertise: moment.Moment;
    nouveauPrelevement: Boolean;
    idCommission: number;
    idNouveauPrelevement: number;
}
